import { createSelector } from 'reselect';
import { getConfigData } from 'src/modules/config/selectors/getConfigData';

export const getCurrentDate = createSelector([
  getConfigData,
], (config) => config.currentDate);
